import React from 'react';
import PropTypes from 'prop-types';
import CrudContext from 'react/contexts/DefaultContext';

const FormSectionColumn = ({ className, children }) => (
  <CrudContext.Consumer>
    {
      ({ isGrid }) => (
        isGrid ? children : (
          <div className={`formSectionColumn ${className}`}>
            { children }
          </div>
        )
      )
    }
  </CrudContext.Consumer>
);

FormSectionColumn.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};

FormSectionColumn.defaultProps = {
  className: ''
};

export default FormSectionColumn;
